export const testGraphHeights = {
  10: [
    2.5, 3.8, 5, 7.5, 8.9, 12.1, 14.4, 17.9, 21.8, 26.3, 31.7, 37.8, 44.1, 51.4,
    61.5, 70.7, 81.8, 94.1, 106.5, 120.1, 129.4, 138.8, 145.5, 149.8, 151.5,
    151.5, 149.8, 145.5, 138.8, 129.4, 120.1, 106.5, 94.1, 81.8, 70.7, 61.5,
    51.4, 44.1, 37.8, 31.7, 26.3, 21.8, 17.9, 14.4, 12.1, 8.9, 7.5, 5, 3.8, 2.5,
  ],
  12: [
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3.8, 4.5, 5, 6, 7.6, 10.4, 12.8, 15.7, 21,
    25.6, 31.4, 36.1, 42, 48.5, 56.2, 64.2, 72.2, 81.7, 93, 101.2, 110.2, 120,
    131, 139, 147.6, 152.7, 155.2, 150.2, 139, 108.2,
  ],
  16: [
    2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 3, 3.5, 4, 4.5, 5, 6,
    6.5, 7, 7.5, 8.5, 9.5, 12.1, 14.4, 17.9, 19.9, 24.1, 29, 34.5, 40.3, 47,
    56.2, 64.7, 77.9, 89.6, 101.4, 112.9, 126.4, 138.8, 145.5, 149.8, 151.5,
    151.5, 149.8, 145.5, 138.8, 126.4, 112.9, 101.4, 89.6, 77.9, 64.7, 56.2, 47,
    40.3, 34.5, 29, 24.1, 19.9, 16.3,
  ],
  37: [
    2.5, 5, 8.9, 14.4, 21.8, 31.7, 37.8, 44.1, 51.4, 61.5, 70.7, 81.8, 94.1,
    106.5, 120.1, 129.4, 138.8, 145.5, 149.8, 151.5, 151.5, 149.8, 145.5, 138.8,
    129.4, 120.1, 106.5, 94.1, 81.8, 70.7, 61.5, 51.4, 44.1, 37.8, 31.7, 21.8,
    14.4, 8.9, 5, 2.5,
  ],
  43: [
    2.5, 2.5, 5, 8, 9.5, 14, 16, 21, 25, 34, 43, 62, 80, 98, 115, 129, 142,
    151.5, 151.5, 142, 129, 115, 98, 80, 62, 43, 34, 25, 21, 18,
  ],
};

export const scaleTraitFieldToPretty = {
  10: {
    spatialPercentile: "Spatial Reasoning Percentile",
    verbalPercentile: "Verbal Ability Percentile",
    mathPercentile: "Math and Logic Percentile",
  },
  12: {
    verbalCorrect: "Verbal Raw Score",
    mathCorrect: "Math Raw Score",
  },
  13: {
    AGR: "Agreeableness",
    CON: "Conscientiousness",
    EXT: "Extroversion",
    OPE: "Openness",
    STR: "Stress Tolerance",
  },
  14: { ATT: "Attention", MEM: "Memory", REA: "Reasoning" },
  23: {
    DA: "Divided Attention",
    VIG: "Vigilance",
    FIL: "Filtering",
    PRT: "Reaction Time",
  },
  31: {
    CON_percentile: "Conscientiousness",
    PER_percentile: "Perseverance",
    HON_percentile: "Integrity/Honesty",
    THEFT_percentile: "Attitude Towards Theft",
  },
  34: {
    ACH_adjPercentile: "Achievement",
    MOT_adjPercentile: "Motivation",
    CMP_adjPercentile: "Competitiveness",
    MGT_adjPercentile: "Managerial",
    AST_adjPercentile: "Assertiveness",
    EXT_adjPercentile: "Extroversion",
    COP_adjPercentile: "Cooperativeness",
    PAT_adjPercentile: "Patience",
    SCN_adjPercentile: "Self-Confidence",
    CON_adjPercentile: "Conscientiousness",
    OPEN_adjPercentile: "Openness",
    STAB_adjPercentile: "Stress Tolerance",
  },
  37: {
    logicPercentile: "Logic and Analysis",
    mathPercentile: "Numerical Reasoning",
    detailPercentile: "Attention to Detail",
    spatialPercentile: "Spatial Reasoning",
  },
  42: {
    detailPercentile: "Attention to Detail",
    verbalPercentile: "Verbal Ability",
    mathPercentile: "Numerical Reasoning",
  },
};
